import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AnimatedLink from "@components/link/AnimatedLink";
export const SidebarPerson = ({ url, image, jobTitle, fullName }) => {
    const renderPersonName = () => {
        if (!!url) {
            return _jsx(AnimatedLink, { label: fullName, url: url, hoverColor: "cta-blue", color: "cta-blue", className: "sidebar__person-name" });
        }
        return _jsx("p", { className: "sidebar__person-name text-charcoal", children: fullName });
    };
    return (_jsxs("address", { children: [!!image && _jsx("img", { src: image.url, alt: image.altText, width: "120", className: "sidebar__person-img" }), !!fullName ? renderPersonName() : null, !!jobTitle && _jsx("div", { className: "sidebar__person-title", dangerouslySetInnerHTML: { __html: jobTitle } })] }, url));
};
